// Navbar.js
import React from "react";
import { Link } from "react-router-dom";
import classes from "./Navbar.module.css";
import CartDrawer from "./CartDrawer";

export default function Navbar() {
  return (
    <nav className={classes.navbar}>
      <div className={classes.navContainer}>
        <Link to="/" className={classes.logo}>
          <h2>פרחי נסטל</h2>
        </Link>

        <ul className={classes.navMenu}>
          <li>
            <Link to="/orders" className={classes.navLink}>
              הזמינו עכשיו
            </Link>
          </li>
          <li>
            <CartDrawer />
          </li>
        </ul>
      </div>
    </nav>
  );
}
